import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';

export const KioskTextInputHintWrap = ({
  inputHint,
  children,
  showButtonHint = true,
}: {
  inputHint: string;
  children: React.ReactNode;
  showButtonHint?: boolean;
}) => {
  const { t } = useCommonTranslation();
  return (
    <>
      <div>{inputHint}</div>
      {children}
      {showButtonHint && <div>{t('kiosk-button-hint')}</div>}
    </>
  );
};
